import { render, staticRenderFns } from "./SensorListHandler.vue?vue&type=template&id=0fbcc384"
import script from "./SensorListHandler.vue?vue&type=script&lang=ts"
export * from "./SensorListHandler.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports